import { defineComponent, computed } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Badge",
  props: {
    type: { default: "primary" },
    value: { default: "" },
    max: { default: 99 },
    hidden: { type: Boolean, default: false },
    isDot: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const showBadge = computed(() => !props.hidden && (props.value || props.isDot));
    const content = computed(() => {
      if (props.isDot) return "";
      if (typeof props.value === "number" && typeof props.max === "number") {
        return props.value > props.max ? `${props.max}+` : props.value;
      }
      return props.value;
    });
    const badgeClass = computed(() => [
      "tui-badge",
      `tui-badge-${props.type}`,
      props.isDot ? "tui-badge-isDot" : ""
    ]);
    return { __sfc: true, props, showBadge, content, badgeClass };
  }
});
export {
  _sfc_main as default
};
